import gql from 'graphql-tag';

export const CURRENT_BILLING_PERIOD_USAGE_SECTION_ORG_INFO = gql`
  query CurrentBillingPeriodUsageSectionOrgInfo($orgName: String!) {
    organization(name: $orgName) {
      id
      name
      createdAt
      usedSeats
      teams {
        id
        name
        storageBytes
      }
      subscriptions {
        id
        billingPeriodStart
        billingPeriodEnd
        subscriptionType
        seats
        plan {
          id
          name
          planType
        }
      }
    }
  }
`;

export const ENTERPRISE_BILLING_PERIOD_ORG_INFO = gql`
  query EnterpriseBillingPeriodOrgInfo($orgName: String!) {
    organization(name: $orgName) {
      id
      weaveEnterpriseSubscription {
        billingPeriodStart
        billingPeriodEnd
      }
    }
  }
`;

export const USAGE_TOTAL_INFO = gql`
  query UsageTotalInfo(
    $orgName: String!
    $usageType: UsageType!
    $intervalMarkers: [DateTime!]!
  ) {
    organization(name: $orgName) {
      id
      createdAt
      usageTotal(usageType: $usageType, intervalMarkers: $intervalMarkers)
    }
  }
`;
